import apiClient from './axios';
import axios from 'axios';

export interface CharacterRegistration {
  characterClass: string;
  characterNickname: string;
  itemLevel: string;
  classType?: string;
}

export interface Character {
  characterId: number;
  memberId: string;
  characterClass: string;
  characterNickname: string;
  itemLevel: string;
  classType: string;
  characterNumber: number;
}

export interface LostArkCharacter {
  ServerName: string;
  CharacterName: string;
  CharacterLevel: number;
  CharacterClassName: string;
  ItemAvgLevel: string;
  ItemMaxLevel: string;
}

/**
 * Lost Ark API 키 조회
 */
export const getLostArkApiKey = async (): Promise<string> => {
  const response = await apiClient.get<{ apiKey: string }>('/api/characters/api-key');
  return response.data.apiKey;
};

/**
 * Lost Ark API로 캐릭터 검색
 */
export const searchLostArkCharacter = async (characterName: string): Promise<LostArkCharacter[]> => {
  const apiKey = await getLostArkApiKey();

  const response = await axios.get<LostArkCharacter[]>(
    `https://developer-lostark.game.onstove.com/characters/${characterName}/siblings`,
    {
      headers: {
        'Authorization': `bearer ${apiKey}`,
        'Accept': 'application/json',
      },
    }
  );

  return response.data;
};

/**
 * 내 캐릭터 목록 조회
 */
export const getMyCharacters = async (): Promise<Character[]> => {
  const response = await apiClient.get<Character[]>('/api/characters/me');
  return response.data;
};

/**
 * 캐릭터 재등록 (기존 캐릭터 삭제 후 등록)
 */
export const updateCharacters = async (characters: CharacterRegistration[]) => {
  const response = await apiClient.put<{
    success: boolean;
    message: string;
    count: number;
  }>('/api/characters/batch', characters);
  return response.data;
};

/**
 * 캐릭터 레벨 업데이트
 */
export const updateCharacterLevels = async (levelMap: Record<string, string>) => {
  const response = await apiClient.put<{
    success: boolean;
    message: string;
  }>('/api/characters/levels', levelMap);
  return response.data;
};

/**
 * 내 캐릭터 전체 삭제
 */
export const deleteAllMyCharacters = async () => {
  const response = await apiClient.delete<{
    success: boolean;
    message: string;
  }>('/api/characters/me');
  return response.data;
};

/**
 * 캐릭터 닉네임 중복 체크
 */
export const checkCharacterNicknameDuplicate = async (characterNickname: string): Promise<boolean> => {
  const response = await apiClient.get<{ available: boolean; characterNickname: string }>(
    '/api/characters/check-name-duplicate',
    { params: { characterNickname } }
  );
  return response.data.available;
};
